<template>
   
      <div class="card-panels pt-0">
        
     
        <div class="main-list-wrap forms_title mb-0 fees_actions fees_actions_v2" v-if="checkProperty(petition ,'filingFeeDetails') && checkProperty(petition,'filingFeeDetails','amount') > 0 ">
      
          <div >
          <ul class="items-list" >
           
            <!-- <li>Status<span>Raised</span></li>
            <li>Last Updated <span>{{petition.filingFeeDetails.createdOn | formatDate}}</span></li> -->
            <li>Total Amount<span>{{formatprice(totalInvoiceAmountPaid)}}</span></li>
            <li>Paid Amount<span>{{formatprice(partlyPaidAmountt)}}</span></li>
            <li>Due Amount<span>{{formatprice(totalDueAmount)}}</span></li>

            <li v-if="checkProperty(petition, 'dueDate')">Due Date<span>{{checkProperty(petition, 'dueDate') | formatDate}}</span></li>
            <li v-if="checkProperty(petition, 'invoiceDetails', 'createdOn')">Issued Date<span>{{checkProperty(petition, 'invoiceDetails', 'createdOn') | formatDate}}</span></li>
            <li v-if="checkProperty(petition, 'invoiceDate')">Invoice Date<span>{{checkProperty(petition, 'invoiceDate') | formatDate}}</span></li>

            
            <li v-if="checkProperty(petition['filingFeeDetails'],'statusDetails','name')">
              <span :class="{'status_invite':checkProperty(petition['filingFeeDetails'],'statusDetails','id')==1 ,'status_fullypaid':checkProperty(petition['filingFeeDetails'],'statusDetails','id')==6, 'status_partiallypaid':checkProperty(petition['filingFeeDetails'],'statusDetails','id')==5 }"
              
              class="ml-0 status-btn2 status_sent">{{checkProperty(petition['filingFeeDetails'],'statusDetails','name')}}</span></li>
          

          </ul>
          </div>
          
          
        </div>

        <!-- <h4 v-if="petitionInvoiceList.length > 0">Invoices</h4> -->
        <div class="accordian-table sub-table padt20" v-if="petitionInvoiceList.length > 0">
          <h3 class="small-header">
            Invoices
            </h3>
        <div class="vs-table--content">
          <div class="vs-con-tbody">
            <table class="vs-table vs-table--tbody-table">
              <thead class="vs-table--thead">
                <tr>
                  <th>
  
                    <div class="vs-table-text d-flex">
                      <a @click="sortMe('customId')"
                        v-bind:class="{ 'sort_ascending': sortKeys['customId'] == 1, 'sort_descending': sortKeys['customId'] != 1 }">Invoice No
                      </a>
                    </div>
                  </th>

                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('createdOn')"
                        v-bind:class="{ 'sort_ascending': sortKeys['createdOn'] == 1, 'sort_descending': sortKeys['createdOn'] != 1 }">Issued On</a>
                    </div>
                  </th>
                  
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('amount')"
                        v-bind:class="{ 'sort_ascending': sortKeys['amount'] == 1, 'sort_descending': sortKeys['amount'] != 1 }">Amount</a>
                    </div>
                  </th>

                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('paymentStatus')"
                        v-bind:class="{ 'sort_ascending': sortKeys['paymentStatus'] == 1, 'sort_descending': sortKeys['paymentStatus'] != 1 }">Payment Status</a>
                    </div>
                  </th>
                  <th class="actions">Actions
                 </th>
                </tr>
              </thead>
              <!-- class="cursor-pointer" -->
              <tr class="vs-table--tr" v-for="(invoiceItem, index) in petitionInvoiceList" :key="index">
                <td class="td vs-table--td cursor-pointer">
                  <span @click="showDetails(invoiceItem)">
                    <div> {{ invoiceItem.customId }} </div>
                    <div class="IB_tooltip IB_tooltip_v2 placement-right" v-if="checkProperty(invoiceItem, 'qbErrorMessage') || checkProperty(invoiceItem, 'qbInvoiceId') ">
                      <span>
                        <template v-if="checkProperty(invoiceItem, 'qbInvoiceId')">
                        <svg id="Group_76375" data-name="Group 76375" xmlns="http://www.w3.org/2000/svg" width="24.004" height="24.004" viewBox="0 0 24.004 24.004">
                          <circle id="Ellipse_574" data-name="Ellipse 574" cx="9.002" cy="9.002" r="9.002" transform="translate(2.4 2.529)" fill="#fff"/>
                          <g id="check">
                            <g id="Group_8119" data-name="Group 8119">
                              <path id="Path_34467" data-name="Path 34467" d="M12,0A12,12,0,1,0,24,12,12.049,12.049,0,0,0,12,0ZM10.55,17.461,5.294,12.205l1.989-1.989,3.359,3.359,6.743-6.13,1.893,2.081Z" fill="#27a438"/>
                            </g>
                          </g>
                        </svg> 
                      </template>
                      <template v-if="checkProperty(invoiceItem, 'qbErrorMessage')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><defs></defs><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z" fill="#ec1c24"/></svg>
                      </template>
                      </span>
                       <div class="tooltip_cnt"><p>
                        <template v-if="checkProperty(invoiceItem, 'qbInvoiceId')">In sync with QuickBooks</template>
                        <template v-if="checkProperty(invoiceItem, 'qbErrorMessage')">{{checkProperty(invoiceItem, 'qbErrorMessage')}}</template>
                       </p></div>
                    </div>
                  </span>
                </td>
                <td class="td_label">
                  <div >
                      {{checkProperty(invoiceItem, 'createdOn') |formatDate}} <br />
                      <small v-if="checkProperty(invoiceItem, 'createdByDetails', 'name')">{{ checkProperty(invoiceItem, 'createdByDetails', 'name') }} 
                        <template v-if="checkProperty(invoiceItem, 'createdByDetails', 'roleName')">({{ checkProperty(invoiceItem, 'createdByDetails', 'roleName')}}) </template>
                      </small>
                    </div>
                 
                </td>
                <td class="td vs-table--td">
                    <template v-if="invoiceItem && (invoiceItem.amount || invoiceItem.amount == 0)">{{formatprice(invoiceItem.amount)}} </template>
                </td>
                

                <td class="td vs-table--td">
                    <span :statusId="checkProperty(invoiceItem, 'statusDetails', 'id')" class="statusspan "
                  v-bind:class="{ [getCaseColors(checkProperty(invoiceItem, 'statusDetails', 'id'))]: true }">
                  {{ checkProperty(invoiceItem, 'statusDetails', 'name') }}
                </span>
                </td>
                <td>
                  <button class="IB_primary-btn sm" @click="showDetails(invoiceItem)">Details</button>
                </td>
                <td v-if="false">
                    <vs-dropdown
                  class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent>
                    <more-vertical-icon size="1.5x" class="custom-class cursor"></more-vertical-icon>
                  </a>
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item>
                      <a href.prevent style="cursor:pionter;padding:3px 10px" @click="showDetails(invoiceItem)"><span>Show Details</span></a>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>













        <div class="actions-btn-list actions-btn-listv2" v-if="checkProperty(petition, 'completedActivities', 'length')>0 && (petition.completedActivities.indexOf('SUBMIT_TO_LAW_FIRM') >-1 || [9].indexOf(checkProperty(petition,'typeDetails', 'id')) >-1)"> 
          <div >
            <label v-if="checkProperty(petition, 'invoiceDetails', 'customId') && false">Invoice No
            <span>{{ checkProperty(petition, 'invoiceDetails', 'customId') }}</span></label>
          </div>
          <ul>
            
            <li v-if="checkFIlingFeeEditPermession && checkProperty(getPetitionDetails ,'status' )!=false && checkCreateButton"> 
             
              <span v-if="!checkProperty(petition, 'isFilingfee')" class="items_edit" @click="updateFilingFee(false)">
                <img src="@/assets/images/main/icon-edit.svg" />Enter Filing Fees
              </span>
            </li>

            <li v-if="checkCompletePaymentBtn && false">
              <vs-button class="light-blue-btn btn_primary ml-2 payment_action"   @click="opencreatePopup()">
                Complete Payment
              </vs-button>
            </li>
            <li v-if="enableGenerateButton && (isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1 )">
              <vs-button class="light-blue-btn btn_primary ml-2 payment_action"   @click="showInvoice(true)">
                Generate Invoice
              </vs-button>
            </li>

          </ul>
        </div>
        <div class="text-danger text-sm formerrors mt-3" v-if="false && (newlyAddInvoiceItems.length>0 || removedInvoiceItems.length>0 ) && ( checkFIlingFeeEditPermession && checkProperty(getPetitionDetails ,'status' )!=false && checkCreateButton )">
          <vs-alert color="warning"  class="warning-alert reg-warning-alert no-border-radius"  icon-pack="IntakePortal"  icon="IP-information-button"
            active="true"   >
            <template >
            We have observed that, There is a change in the case details and it will required to update the invoice. <span class="buttonlink" @click="updateFilingFee(true)">Click here</span> to update the Invoice.
            </template>
            
          </vs-alert>
          
          </div>
          
        <div >
          <div class="accordian-table filingfee_tabel filingfee_tabelv2 padt10">
            <template v-if="checkProperty(petition ,'filingFeeDetails','feeDetails') && (petition.filingFeeDetails.feeDetails.length>0) &&  checkProperty(petition, 'isFilingfee')">
            <template v-if="checkProperty(petition ,'filingFeeDetails','feeDetails') && (petition.filingFeeDetails.feeDetails.length>0)" >
                <vs-table :data="petition.filingFeeDetails.feeDetails" class="fees_table  "> 
                  <template slot="thead">
                    <vs-th>
                      <vs-checkbox v-if="isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1" @change="selectedAllInvoice()" :disabled="checkDisabled" :name="'selecteAll'"  v-model="selectAllInvoice"></vs-checkbox>
                      Filing Fees
                    </vs-th>
                    <vs-th>
                      <!-- Amount -->
                      <span v-if="!checkDisabled && checkProperty(petition, 'completedActivities', 'length')>0 && (petition.completedActivities.indexOf('SUBMIT_TO_LAW_FIRM') >-1 || [9].indexOf(checkProperty(petition,'typeDetails', 'id')) >-1) &&
                checkFIlingFeeEditPermession && checkProperty(getPetitionDetails ,'status' )!=false && checkCreateButton  && checkProperty(petition, 'isFilingfee')" 
               class="cursor items_edit" @click="updateFilingFee(true) ">
                <img src="@/assets/images/main/icon-edit.svg" />Edit
              </span>
                    </vs-th>
                    <vs-th v-if="false" >
                      Exclude from Invoice
                    </vs-th> 
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr class="subhead" v-if="getUscisSection">
                      <vs-td :class="{'padl10':!(isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1)}" colspan="2">
                        <h3 class="small-header">USCIS Fees</h3>
                      </vs-td>
                    </vs-tr>
                    <tbody v-if="getUscisSection">
                      <vs-tr v-for="filingfee in data" :name="'selected_' +filingfee" :key="filingfee" v-if="filingfee.type=='USCIS'">
                        
                        <vs-td>
                          <vs-checkbox v-if="isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1" @change="selectForInvoice(filingfee)" :disabled="filingfee.isSelected" v-model="filingfee.invoiceSelected" ></vs-checkbox>
                          <span v-html="filingfee.name"></span>
                          <span v-if="checkProperty(filingfee, 'online')" class="online_label">Online</span>
                          
                        </vs-td>

                        <vs-td>
                          {{formatprice(filingfee.amount)}}
                        </vs-td>

                        <vs-td  v-if="false">
                          <template v-if="filingfee.invoice">
                            <img   src="@/assets/images/main/checkmark.svg">
                        </template>
                        <template v-else>N/A</template>
                          

                        </vs-td>
                      </vs-tr>
                    </tbody>
                    <vs-tr class="subhead" v-if="getInternalSection">
                      <vs-td :class="{'padl10':!(isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1)}" colspan="2">
                    <h3 class="small-header">Attorney Fees</h3>
                    </vs-td>
                    </vs-tr>
                    <tbody v-if="getInternalSection">
                      <vs-tr v-for="filingfee in data" :name="'selected_' +filingfee" :key="filingfee" v-if="filingfee.type=='Internal'"> 
                        <vs-td >  
                          <vs-checkbox v-if="isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1" @change="selectForInvoice(filingfee)" 
                            :disabled="(filingfee.isSelected && !filingfee.allowMultiple) || (filingfee.isSelected && filingfee.allowMultiple && checkEnableFee)"  
                            v-model="filingfee.invoiceSelected" ></vs-checkbox>
                          <span v-html="filingfee.name"></span>
                          <span v-if="checkProperty(filingfee, 'allowMultiple')" class="online_label blue">Multiple</span>
                        </vs-td>
                        <vs-td>
                          {{formatprice(filingfee.amount)}}
                        </vs-td>
                        <vs-td  v-if="false">
                          <template v-if="filingfee.invoice">
                            <img   src="@/assets/images/main/checkmark.svg">
                          </template>
                          <template v-else>N/A</template>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                    <vs-tr class="subhead" v-if="getotherSection">
                      <vs-td :class="{'padl10':!(isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1)}" colspan="2">
                    <h3 class="small-header">Other Fees</h3>
                    </vs-td>
                    </vs-tr>
                    <tbody v-if="getotherSection">
                      <vs-tr v-for="filingfee in data" :name="'selected_' +filingfee" :key="filingfee" v-if="['Other','other'].indexOf(filingfee.type)>-1"> 
                        <vs-td >  
                          <vs-checkbox v-if="isAdmin || invoiceCreators.indexOf(getUserRoleId)>-1" @change="selectForInvoice(filingfee)" 
                            :disabled="(filingfee.isSelected && !filingfee.allowMultiple) || (filingfee.isSelected && filingfee.allowMultiple && checkEnableFee)"  
                            v-model="filingfee.invoiceSelected" ></vs-checkbox>
                          <span v-html="filingfee.name"></span>
                          <span v-if="checkProperty(filingfee, 'allowMultiple')" class="online_label blue">Multiple</span>
                        </vs-td>
                        <vs-td>
                          {{formatprice(filingfee.amount)}}
                        </vs-td>
                        <vs-td  v-if="false">
                          <template v-if="filingfee.invoice">
                            <img   src="@/assets/images/main/checkmark.svg">
                          </template>
                          <template v-else>N/A</template>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </template>
              <template v-if="false">
                <vs-table :data="petition.filingFeeDetails.feeDetails" class="fees_table padt10"> 
                  <template slot="thead">
                    <vs-th>
                      Fee Type   
                    </vs-th>
                    <vs-th>
                      Amount
                    </vs-th>
                    <vs-th >
                      Exclude from Invoice
                    </vs-th> 
                  </template>

                  <template slot-scope="{data}">
                      <vs-tr v-for="filingfee in data" :key="filingfee" >
                        <vs-td v-html="filingfee.name">
                          
                        </vs-td>

                        <vs-td>
                          {{formatprice(filingfee.amount)}}
                        </vs-td>

                        <vs-td>
                          <template v-if="filingfee.invoice">
                             <img   src="@/assets/images/main/checkmark.svg">
                        </template>
                        <template v-else>N/A</template>
                          

                        </vs-td>
                      </vs-tr>
                    </template>
                </vs-table>
              </template>
            </template>
              <template v-if="!(checkProperty(petition ,'filingFeeDetails','feeDetails') && (petition.filingFeeDetails.feeDetails.length>0) && checkProperty(petition, 'isFilingfee'))"> 
             
                <NoDataFound ref="NoDataFoundRef" :loading="false" content="" heading="No Fees/Invoices Found" type='Fees/Invoices' />
              </template>
           
            
          </div>

          
 
        </div>
        <template v-if="checkProperty(petition ,'filingFeeDetails','partlyPaidLogs') && (petition.filingFeeDetails.partlyPaidLogs.length>0)" >
          <div class="accordian-table filingdata_table filingdata_table_v2 pad mt-8">
            <paymentList :petition="petition" />
          </div>
        </template>
       
        <template v-if="(checkProperty(petition,'filingFeeDocs') && checkProperty(petition ,'filingFeeDocs', 'cheques') && checkProperty(petition['filingFeeDocs'],'cheques','length')>0) && false">
         <div class="px-6">
          <documentsView @download_or_view="download_or_view" :type="'Cheques'" :label="'Cheques'"  :documentsList="petition['filingFeeDocs']['cheques']" :petitionDetails="petition" />
         </div>
        </template> 
        <addPayment
          @updatepetition="updatepetition"
          :petitionDetails="petition"
          :ACTIVITYCODE="ACTIVITYCODE"
          @hideMe="addPaymentPopup = false;"
          v-if="addPaymentPopup"
        />
        <invoicePayment
          @updatepetition="updatepetition"
          :petitionDetails="updatedFillingDetails"
          @hideMe="openInvoicePopup = false;getInvoiceList()"
          v-if="openInvoicePopup"
        />
        <vs-popup class="holamundo main-popup cls-btn" title="Generate Invoice" :active.sync="showInvoiceCreatePopup">
            <div class="form-container"> 
              <div class="vx-row" v-if="false">
                  <div class="vx-col w-full">
                      <p style="line-height: 20px">
                          Are you sure to generate Invoice?
                      </p>
                  </div>
              </div>
              <!-- <fileUploadNote :fileNote="true" /> -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="form_group mb-5">
                    <label class="form_label">Cheques</label>
                    <div class="vs-component relative mb-1">                  
                      <file-upload
                        :multiple="true"
                        :hideSelected="true"
                        v-model="documents"
                        class="file-upload-input file_upload justify-center"
                        name="documentsUpload"
                        :accept="allDocEntity" 
                        @updateData="updateData"
                      >Upload
                      </file-upload>
                    </div>
                    <ul class="uploaded-list note_uploads mt-2" v-if="checkProperty(filingFeeDocuments, 'length') > 0">
                      <template v-for="(file, fileindex) in filingFeeDocuments">
                        <vs-chip
                          type="button"
                          @click="removeFiles(fileindex)"
                          :key="fileindex"
                          v-if="file.status !== false"
                          closable
                          >{{ file.name }}
                        </vs-chip>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="popup-footer relative">
              <span class="loader" v-if="invoiceLoading" ><img src="@/assets/images/main/loader.gif"/></span>
              <vs-button color="dark" class="cancel" type="filled" @click="showInvoice(false)">Cancel</vs-button>
              <vs-button color="success" class="save" type="filled" @click="createInvoice()">Submit</vs-button>
            </div>
        </vs-popup>
        <!-- <invoiceEditPopup
        :petition="updatedFillingDetails"
        v-if="showInvoiceEditPopup" /> -->

        <div  v-if="showDetailsPopup" class="workflow_view_wrap taskmanagement emailtemplate" :class="{ listopen: showDetailsPopup }">
        <div class="workflow_overlay"></div>
        <div class="workflow_view_cnt questionary_cnt bulkemail_details" style="width:850px">
          <div class="workflow_view_title view__title email_title-v2" :class="{ 'pr-0': type == 'showWorkflowview' }" >
            <span class="close" @click="showDetailsPopup = false;getInvoiceList();updatepetition()"><x-icon size="1.5x" class="custom-class"></x-icon></span>
          </div> 
            <invoiceDetail :callFromCaseDetails="true" :ref="'invoiveDetailsPopup'" @hideMePopup="hideMePopup" @reloadDetails="reloadDetails" v-if="invoiceDetails" @download_or_view="download_or_view" :invoiceData="invoiceDetails" />
          <div> 
          </div>
          
        </div>
        
      </div>
       
      </div>
     



   
</template>

<script>
import invoiceDetail from "@/views/invoice/invoiceDetails.vue"
import { XIcon, MoreVerticalIcon } from 'vue-feather-icons'
import documentsView from "@/views/common/documentsView.vue";
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
import fileUploadNote from "@/views/common/fileUploadNote.vue";
import addPayment from "@/views/actionpopups/perm/addPayment.vue"; 
import invoicePayment from "@/views/actionpopups/perm/addPayment.vue"; 
import paymentList from "@/views/petition/paymentList.vue"
// import FileUpload from "vue-upload-component/src";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NoDataFound from "@/views/common/noData.vue";
import _ from "lodash";
import FileUpload from "@/views/FileUpload.vue";
// import invoiceEditPopup from "@/views/actionpopups/invoiceEditPopup.vue"; 
export default {
  computed:{
    getUscisSection(){
      let returnVal = false;
      // filingFeeData type USCIS
      if(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0 ){
        let findObj = _.find(this.petition['filingFeeDetails']['feeDetails'], {'type':'USCIS'});
        if(findObj){
          returnVal = true;
        }
      }
      return returnVal;
    },
    getInternalSection(){
      let returnVal = false;
      // filingFeeData type USCIS
      if(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0 ){
        let findObj = _.find(this.petition['filingFeeDetails']['feeDetails'], {'type':'Internal'});
        if(findObj){
          returnVal = true;
        }
      }
      return returnVal;
    },
    getotherSection(){
      let returnVal = false;
      // filingFeeData type USCIS ['Other','other'].indexOf(filingfee.type)>-1
      if(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0 ){
        let findObj = _.find(this.petition['filingFeeDetails']['feeDetails'], {'type':'Other'});
        let findOther = _.find(this.petition['filingFeeDetails']['feeDetails'], {'type':'other'});
        if(findObj){
          returnVal = true;
        }else if(findOther){
          returnVal = true;
        }
      }
      return returnVal;
    },
    checkEnableFee(){
      let returnVal = true;
      if(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0 ){
        let list = _.filter(this.petition['filingFeeDetails']['feeDetails'], (item)=>{
          if(!item['isSelected']){
            return item
          }
        })
        if(list && list.length>0){
          returnVal = false;
        }
      }
      return returnVal
    },
    checkDisabled(){
      let returnVal = true;
      if(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0 ){
        let list = _.filter(this.petition['filingFeeDetails']['feeDetails'], (item)=>{
          if(!item['isSelected']){
            return item
          }
        })
        if(list && list.length>0){
          returnVal = false;
        }
      }
      return returnVal
    },
    checkPaid(){
      return (data)=>{
        let returnVal = 0;
        let petition = data['field'];
        if(this.checkProperty(petition,'partlyPaidLogs') && this.checkProperty(petition,'partlyPaidLogs','length')>0 ){
          let filingfeeList = _.cloneDeep(this.checkProperty(petition,'partlyPaidLogs'))
          filingfeeList.forEach(item => {
            returnVal += item.amount;
          });
        }
        return returnVal
      }
      
    },
    checkDueAmount(){
      return (data)=>{
        let returnVal = 0;
        let petition = data['field'];
        let paidVal = this.checkPaid({'field':data['field']});
        if(paidVal > 0 && this.checkProperty(petition,'amount')>0){
          let total = parseInt( this.checkProperty(petition,'amount'))
          returnVal = total - paidVal
        }
        return returnVal
      }
    }, 
   
    checkCompletePaymentBtn(){
       let returnVal =false;
      if(this.workFlowDetails && _.has(this.workFlowDetails ,'config') ){
       
        let enableFilingFee = false;
        let filingEditors =[];
        let isAdmin =false;
        let adminsList =[];
          let adminsactiVityList = _.find(this.workFlowDetails.config , {"code":'MANAGER_LIST'});
        if(adminsactiVityList && adminsactiVityList.editors){
        
           adminsList = _.map(adminsactiVityList.editors, 'roleId');
        }
       
        let filingFeeActivity = _.find(this.workFlowDetails.config , {"code":'FILING_FEE'});
        if(filingFeeActivity && filingFeeActivity.actionRequired == "Yes"){
        
          enableFilingFee = true;
         filingEditors =_.map(filingFeeActivity.editors, 'roleId');
        }

          
          isAdmin = adminsList.indexOf(this.getUserRoleId) > -1
     
          if((  isAdmin || filingEditors.indexOf(this.getUserRoleId) > -1) && this.checkProperty(this.petition ,'invoiceId') && enableFilingFee && this.checkProperty( this.petition ,'invoiceDetails' ,'statusId') < 6  ){
            returnVal =true;
          }
        }
        return returnVal

      
    },
    checkCreateButton(){
      let returnValue =true;
      if(this.loadedFromPreview==true || (this.checkProperty(this.petition ,'intStatusId')) !=1){
        returnValue =false;
      }

      return returnValue;


    },
    checkInvoiceExists(){
      if(_.get( this.petition ,'filingFeeDetails.feeDetails')){

        let invoiceItems =_.filter(this.petition.filingFeeDetails.feeDetails ,{ "invoice":true});
      if(invoiceItems && invoiceItems.length>0){
        return true;
      }else{
        return false;
      }

      }else{
        return false
      }
      

    },
  },
  props: {
    loadedFromPreview:false,
     currentRole:null,
     currentUser:null,
    petition: {
      type: Object,
      default: null
    },
    workFlowDetails: {
      type: Object,
      default: null,
    },
  },
  components: {
    XIcon,
    invoiceDetail,
    //invoiceEditPopup,
    MoreVerticalIcon,
    fileUploadNote,
    documentsView,
    addPayment,
    invoicePayment,
    paymentList,
    FileUpload,
    VuePerfectScrollbar,
    NoDataFound
  },
  
  watch: {
    'petition'(val) {
     
      this.checkPaidAmount()

    }
  },
  methods: {
    checkInvoiceCreation(){
      if(this.workFlowDetails && _.has(this.workFlowDetails ,'config') ){
        let filingEditors =[];
        this.isAdmin =false;
        let adminsList =[];
        this.invoiceCreators = [];
        let adminsactiVityList = _.find(this.workFlowDetails.config , {"code":'MANAGER_LIST'});
        if(adminsactiVityList && adminsactiVityList.editors){
          adminsList = _.map(adminsactiVityList.editors, 'roleId');
        }
        let filingFeeActivity = _.find(this.workFlowDetails.config , {"code":'CREATE_INVOICE'});
        if(filingFeeActivity && filingFeeActivity.actionRequired == "Yes"){
         filingEditors =_.map(filingFeeActivity.editors, 'roleId');
        }
        this.invoiceCreators = filingEditors
        this.isAdmin = adminsList.indexOf(this.getUserRoleId) > -1 
      }
    },
    sortMe(sort_key = '') {
      if (sort_key != '') {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
        this.sortKey = {};
        this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] };
        this.getInvoiceList();
      }
    },
    showDetails(item){
      this.selectedInvoiceListItem = null;
      if(item){
        this.selectedInvoiceListItem = item;
        this.getDetails(this.checkProperty(item, "_id"))
      }
    },
    getDetails(invoiceId, callFromReload=false){

      let query ={  
      "invoiceId": invoiceId?invoiceId:''
      };    
      this.$store
      .dispatch("getList",{data:query ,path:'/invoices/details'} )
      .then(response => {
        this.invoiceDetails = response;
        if(callFromReload){
          this.$refs['invoiveDetailsPopup'].checkPaidAmount()
        }
        //console.log(JSON.stringify(response))
        this.showDetailsPopup =true;
      }).catch(error => {})
    },
    reloadDetails(){
      if(this.checkProperty(this.selectedFeeItem, '_id')){
        this.getDetails(this.checkProperty(this.selectedFeeItem, '_id'), true)
      }
    },
    hideMePopup(){
      this.showDetailsPopup = false;
      this.updatepetition()
      //this.getInvoiceList()
    },
    openEditInvoice(){

    },
    openPaymentPopup(invoiceItem){
      if(invoiceItem){
        this.selectedInvoiceItem = invoiceItem;
        this.updateFeeDetails(true)
      }
    },
    updateFeeDetails(openPop = false){
      this.updatedFillingDetails['filingFeeDetails'] = this.selectedInvoiceItem;
      this.updatedFillingDetails['invoiceId'] = this.checkProperty(this.selectedInvoiceItem, '_id');
      this.updatedFillingDetails['_id'] = this.checkProperty(this.selectedInvoiceItem, 'petitionId');
      this.updatedFillingDetails['typeDetails']['name'] = this.checkProperty(this.selectedInvoiceItem,'petitionDetails', 'typeName');
      this.updatedFillingDetails['typeDetails']['id'] = this.checkProperty(this.selectedInvoiceItem,'petitionDetails', 'type');
      this.updatedFillingDetails['subTypeDetails']['id'] = this.checkProperty(this.selectedInvoiceItem,'petitionDetails', 'type');
      this.updatedFillingDetails['subTypeDetails']['name'] = this.checkProperty(this.selectedInvoiceItem,'petitionDetails', 'subTypeName');
      if(openPop){
        this.openInvoicePopup = true;
      }
    },
    getInvoiceList(){
      let Payload = {
        matcher: {
          title: '',
          petitionerIds: [],
          petitionIds:[],
          caseType: [],
          subType: [],
          caseStatus: [],
          paymentStatus: [],
          createdDateRange: [],
          dueDateRange: [],
        },
        page: 1,
        perpage: 100,
        sorting: this.sortKey,
      };
      if(this.checkProperty(this.petition, '_id')){
        Payload['matcher']['petitionIds'].push(this.checkProperty(this.petition, '_id'))
      }
      this.$store.dispatch("commonAction", { "data": Payload, "path": "/invoices/list" }).then((response) => {
        this.petitionInvoiceList = response.list;
        // console.log(JSON.stringify(this.petitionInvoiceList))
      }).catch((err)=>{

      })
    },
    removeFiles(index){
      let item = this.filingFeeDocuments[index]
      this.filingFeeDocuments.splice(index ,1)
      this.removeFileFromS3(item)
    },
    updateData(docs){
      this.filingFeeDocuments = docs;
    },
    enableGenerateBtn(){
      this.enableGenerateButton = false;
      if(this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0){
        let findObj = _.find(this.petition['filingFeeDetails']['feeDetails'], {'invoiceSelected':true});
        if(findObj){
          this.enableGenerateButton = true;
        }
      }
    },
    selectedAllInvoice(){
      this.seletedInoviceItems = [],
      this.seletedInoviceIds = [],
      _.forEach(this.petition['filingFeeDetails']['feeDetails'], (item) => {
        item.invoiceSelected = false;
        if (this.selectAllInvoice && !item['isSelected'] ) {
          item.invoiceSelected = true;
          this.seletedInoviceIds.push(item._id)
          this.seletedInoviceItems.push(item);
        }
      });
      this.enableGenerateBtn()
    },
    selectForInvoice(invoi){
      let self = this;
      let invoice = invoi
      // console.log(JSON.stringify(invoice));
      if(self.checkProperty(invoice, 'invoiceSelected') && !invoice['isSelected'] ){
        if (self.seletedInoviceIds.indexOf(invoice['_id']) <= -1) {
          self.seletedInoviceIds.push(invoice['_id'])
          if (!self.seletedInoviceItems.includes(invoice)) {
            self.seletedInoviceItems.push(invoice);
          }
        }
      }else {
        self.seletedInoviceIds = _.filter(self.seletedInoviceIds, (item) => {
          return item != invoice['_id']
        })
        self.seletedInoviceItems = _.filter(self.seletedInoviceItems, (item) => {
          return item != invoice
        })
      }
      self.selectAllInvoice = false;
      if (self.checkProperty(self.petition['filingFeeDetails'],'feeDetails', 'length') > 0 && (self.checkProperty(self.petition['filingFeeDetails'],'feeDetails', 'length') == self.checkProperty(self.seletedInoviceItems, 'length'))) {
        self.selectAllInvoice = true;
      }
      self.enableGenerateBtn()
    },
    showInvoice(action = false, updatePetition = false){
      if(action){
        this.showInvoiceCreatePopup = action;
        this.documents = [];
        this.filingFeeDocuments = [];
        if(updatePetition){
          this.updatepetition();
        }
      }else{
        this.showInvoiceCreatePopup = false;
        this.showInvoiceCreatePopup = false;
        this.selectAllInvoice = false;
        this.seletedInoviceItems = [];
        this.seletedInoviceIds = [];
        _.forEach(this.petition['filingFeeDetails']['feeDetails'], (item) => {
          item.invoiceSelected = false;
        });
        this.enableGenerateBtn();
        this.getInvoiceList();
        if(updatePetition){
          this.updatepetition();
        }
      }
      // if(updatePetition){
      //   this.updatepetition();
      // }
    },
    createInvoice(){
      let self = this;
      let postdata = {
        companyName: self.checkProperty(self.petition, "petitionerDetails", "name"),
        beneficiaryName: self.checkProperty(self.petition, "beneficiaryDetails", "name"),
        beneficiaryCustomId: self.checkProperty(self.petition, "beneficiaryDetails", "customId"),
        petitionType: self.checkProperty(self.petition, "typeDetails", "name"), 
        companyId: self.checkProperty(self.petition, "petitionerDetails", "_id"),
        petitionId: self.petition._id,
        feeDetails: [],
        filingFeeDocs:{"cheques":[]},
        amount: null,
        entityType:'case',
        today: moment().format("YYYY-MM-DD"),
        customer: {
          Id: self.checkProperty(self.petition, "companyDetails", "qbCustomerId"),
          displayName: "", //this.petition.companyDetails.name,
          email: "", //this.petition.companyDetails.authorizedSignatory.email,
        },
        invoiceTerms: {
          days: 30,
        },
      };
      var totala = 0;
      let filingFeeData = _.filter(this.petition['filingFeeDetails']['feeDetails'], (item)=>{
        if((item['invoiceSelected'] && !item['isSelected']) 
        || (item['invoiceSelected']  && item['allowMultiple'] && item.type !='USCIS') ){
          item['isSelected'] = true;
          return item
        }
      });
      if(filingFeeData && this.checkProperty(filingFeeData, 'length')>0){
        postdata['feeDetails'] = filingFeeData;
        filingFeeData.forEach((i) => {
          if(parseInt(i.amount)>0 && i['invoiceSelected']){
            totala = totala + parseInt(i.amount);
          }
          
        });
        postdata['amount'] = totala;
      }  
      if(this.filingFeeDocuments && this.checkProperty(this.filingFeeDocuments, 'length')>0){
        postdata['filingFeeDocs']['cheques'] = this.filingFeeDocuments;
      }
      if (this.checkProperty(self.petition, "companyDetails")) {
        postdata["customer"]["Id"] = this.checkProperty(
          self.petition,
          "companyDetails",
          "qbCustomerId"
        );
        postdata["customer"]["displayName"] = this.checkProperty(
          self.petition,
          "authorizedSignatory",
          "name"
        );
        postdata["customer"]["email"] = this.checkProperty(
          self.petition,
          "authorizedSignatory",
          "email"
        );
      } 
      if(this.checkProperty(this.petition, 'typeDetails', 'id') == 3 && this.checkProperty(this.petition, 'subTypeDetails', 'id') == 15 ){
        postdata['entityType'] = 'perm'
      }
      this.invoiceLoading=true;
      this.$store.dispatch("commonAction", {"data":postdata ,"path":"invoices/create"}).then((response) => {
        this.invoiceLoading=false;
       
        this.showInvoiceCreatePopup = false;
        this.showToster({ message: response.message, isError: false });
        setTimeout(()=>{
          self.showInvoiceCreatePopup = false;
          self.showInvoice(false,true)
        },10)
        // if(response){
        //   this.showInvoiceCreatePopup = false;
        //   this.showInvoice(false,true)
          
        // }
        // console.log(JSON.stringify(response))
        // this.invoiceLoading=false;
        // this.showInvoiceCreatePopup = false;
        // //setTimeout(()=>{
        //   self.showInvoiceCreatePopup = false;
        //   self.showInvoice(false,true)
        //   self.showToster({ message: response.message, isError: false });
        //})
        
      }).catch((err)=>{
        this.invoiceLoading=false;
        this.showToster({ message: err, isError: true });
        this.showInvoice()
      })
      
     

    },
    getListcat(){
      this.invoiceNotification ='';
      this.removedInvoiceItems =[];
      this.newlyAddInvoiceItems =[];
      let self = this;
      let payload={  petitionId:'' }
    
      payload['petitionId'] = this.petition['_id']
      self.$store.dispatch("getList",{data:payload ,path:'/invoices/get-filing-fee-categories'} )
      .then((response) => {
        self.invoicecategoryList = response;


        if(this.checkProperty(this.petition ,'invoiceId')  && this.checkProperty(this.petition ,'filingFeeCategoryType') =="pre_defined" && this.invoicecategoryList.length>0){
         let filingFeeData = _.cloneDeep(this.petition.filingFeeDetails.feeDetails);
         //id
         let finalItems =[];
         _.forEach(filingFeeData ,(dbInvoice)=>{
            let isExistsInML = _.find(this.invoicecategoryList ,{ "id": dbInvoice['id']});
            if(isExistsInML){
              finalItems.push(dbInvoice);
            }else{
              this.removedInvoiceItems.push(dbInvoice);
            }

         })
         _.forEach(this.invoicecategoryList ,(invCat)=>{
            let isExistsInML = _.find(filingFeeData ,{ "id": invCat['id']});
            let isAlreadyExists  = _.find(finalItems ,{ "id": invCat['id']});

            if(!isExistsInML && !isAlreadyExists){

            let item = {  amount: null, name: "",  invoice: false,"id":''  };

            item['name'] = this.checkProperty(invCat ,"name");
            item['amount'] = this.checkProperty(invCat ,"amount");
            item['id'] = this.checkProperty(invCat ,"id");
            item['type'] = this.checkProperty(invCat,"type");
            item['newly_add'] = true;
            finalItems.push(item);
            }

         })
         /*
         this.totalInvoiceAmountPaid
         this.partlyPaidAmountt
         this.totalDueAmount
         */


        
      //this.totalPaidAmount;
      let newlyAddedfeeItems = _.filter(finalItems,{'newly_add':true} );
     
     if(newlyAddedfeeItems && this.checkProperty(newlyAddedfeeItems ,'length' )>0 ){
      this.newlyAddInvoiceItems = _.cloneDeep(newlyAddedfeeItems);
      let allItemsDescription = [];
    _.forEach(newlyAddedfeeItems ,(item)=>{
      if(self.checkProperty(item ,'name' )){
            allItemsDescription.push(item.name)
          }
          if(allItemsDescription.length>0){
            self.invoiceNotification =allItemsDescription.join();
          }
        });

        let totalInvoiceAmount = 0
      
        finalItems.forEach(item => {
          if(!item.invoice){
            totalInvoiceAmount += parseInt(item.amount);

          }
          
        });
       // alert("totalInvoiceAmount ="+totalInvoiceAmount +" old totalInvoiceAmount ="+self.partlyPaidAmountt);
        if(totalInvoiceAmount> self.totalInvoiceAmountPaid){
          
        }


      }
     
         

        }

          
              
      }).catch((err)=>{
        
      });
    
    },
    download_or_view(item){
     // alert();
      this.$emit('download_or_view',item);
    },
    updatepetition(){
     
      this.$route['params']['tabname']= 'Fees/Invoices';
      this.$emit("updatepetition" ,'Fees/Invoices');
     
          

    },
    opencreatePopup(){
      //this.$refs["actionsPopup"].openaddPaymentPopup('ADD_PAYMENT');
      this.ACTIVITYCODE = 'ADD_PAYMENT';
     this.addPaymentPopup =true;
    },
    commonMethod(){
      if(this.workFlowDetails && _.has(this.workFlowDetails ,'config') ){
          let adminsactiVityList = _.find(this.workFlowDetails.config , {"code":'MANAGER_LIST'});
        if(adminsactiVityList && adminsactiVityList.editors){
        
           this.adminsList = _.map(adminsactiVityList.editors, 'roleId');
        }
        this.enableFilingFee = false;
        this.filingEditors =[];
        let filingFeeActivity = _.find(this.workFlowDetails.config , {"code":'FILING_FEE'});
        if(filingFeeActivity && filingFeeActivity.actionRequired == "Yes"){
        
          this.enableFilingFee = true;
          //alert(this.enableFilingFee)
          this.filingEditors =_.map(filingFeeActivity.editors, 'roleId');
        }

          this.canPreParePermApplication = this.preparePermActivity.indexOf(this.getUserRoleId) > -1; 
          this.isAdmin = this.adminsList.indexOf(this.getUserRoleId) > -1
     }
      // alert(this.canPreParePermApplication)
      // alert(this.isAdmin)
    },
    checkPaidAmount(){
      let totalInvoiceAmount = 0
      let totalPaidAmount = 0
      if(this.checkProperty(this.petition,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails','length')>0 ){
        let filingfeeList = _.cloneDeep(this.checkProperty(this.petition,'filingFeeDetails','feeDetails'))
        filingfeeList.forEach(item => {
          if(!item.invoice){
            totalInvoiceAmount += item.amount;
          }
        });
      }
      //alert(totalInvoiceAmount)
      if(totalInvoiceAmount != 0){
        this.totalInvoiceAmountPaid = totalInvoiceAmount
        
      }
      if(this.checkProperty(this.petition,'filingFeeDetails','partlyPaidLogs') && this.checkProperty(this.petition['filingFeeDetails'],'partlyPaidLogs','length')>0 ){
        let filingfeeList = _.cloneDeep(this.checkProperty(this.petition,'filingFeeDetails','partlyPaidLogs'))
        filingfeeList.forEach(item => {
          totalPaidAmount += item.amount;
        });
      }
      if(totalPaidAmount != 0){
        this.partlyPaidAmountt= totalPaidAmount
        //alert(this.partlyPaidAmountt)
      }
      if(this.partlyPaidAmountt == 0 && this.totalInvoiceAmountPaid ){
        this.totalDueAmount = this.totalInvoiceAmountPaid 
        //alert( this.totalDueAmount)
      }
      if(this.partlyPaidAmountt && this.totalInvoiceAmountPaid ){
        this.totalDueAmount = this.totalInvoiceAmountPaid - this.partlyPaidAmountt
      }
      this.getListcat();
      this.isCompleted = true
      
  },
      formatprice(amount) {
      return formatter.format(amount);
    },
    updateFilingFee(action=true) {
      this.$emit("showfilingFeesPopup" ,action);
      
    },
    updateFilingList(){
      if(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails', 'length')>0){
        _.forEach(this.checkProperty(this.petition ,'filingFeeDetails','feeDetails'), (item)=>{
          if(!_.has(item, 'invoiceSelected')){
            item['invoiceSelected'] = false;
          }
        })
      }
    },
    init(){
      this.updateFilingList()
      this.checkPaidAmount()
    this.commonMethod();
    setTimeout(() => {
      this.commonMethod();
      this.checkPaidAmount()
    }, 100);
    
    
   

    this.updateLoading(false);
    // if(this.checkProperty(this.petition,'filingFeeDetails','feeDetails') && this.checkProperty(this.petition['filingFeeDetails'],'feeDetails','length')>0 ){
    //   this.checkPaidAmount()
    // }
   
   
    }
  },
  data: () => ({
    invoiceCreators:[],
    showDetailsPopup:false,
    invoiceDetails:null,
    selectedInvoiceListItem:null,
    showInvoiceEditPopup:false,
    openInvoicePopup:false,
    selectedInvoiceItem:null,
    updatedFillingDetails:{
      filingFeeDetails:{},
      typeDetails:{
          name:'',
          id:null
      },
      subTypeDetails:{
          name:'',
          id:null
      },
      invoiceId:'',
      _id:'',
      filingFeeCategoryType:'',
    },
    sortKeys: {},
    sortKey: {},
    petitionInvoiceList:[],
    invoiceLoading:false,
    documents:[],
    filingFeeDocuments:[],
    showInvoiceCreatePopup:false,
    enableGenerateButton:false,
    seletedInoviceItems:[],
    seletedInoviceIds:[],
    selectAllInvoice:false,
    invoiceNotification:'',
    removedInvoiceItems:[],
    newlyAddInvoiceItems:[],
    invoicecategoryList:[],
    preparePermActivity:[],
    addPaymentPopup:false,
    ACTIVITYCODE:null,
    filingEditors:[],
    enableFilingFee:false,
    adminsList:[3,4],
    isAdmin:false,
    canPreParePermApplication:null,
    isCompleted:false,
    partlyPaidAmountt:0,
  totalInvoiceAmountPaid:0,
  totalDueAmount:0,
  }),
  mounted() {
    this.sortKeys = {
      'customId': 1,
      'IssuedToDetails': 1,
      "amount": 1,
      "caseType": 1,
      "caseStatus": 1,
      "createdOn": 1,
      "updatedOn": -1,
      "paymentStatus": 1,
      "beneficiaryName": 1,
    },
    this.sortKey = { "path": 'updatedOn', "order": -1 };
    this.getInvoiceList()
    this.seletedInoviceItems = []
    this.seletedInoviceIds = []
    this.selectAllInvoice = false
    this.init();   
    this.checkInvoiceCreation();
    
    
   
  }
};
</script>